export const AssetBookingConfigBase = {
  BILLING_MODULE: {
    ENABLED: true,
    DISABLED_BILLING_COMPANY_FORM: false,
    DISABLED_FISCAL_RESPONSIBILITY: true,
    IS_OPTIONAL: false,
    ENABLED_FULL_ADDRESS_FORM: true,
  }
};
